import { displayOrderVehicleIdentifier, displayVehicleIdentifier } from "../display/vehicle-identifier";
import { initializeRemoteLogQueue, sendToRemoteLoggerQueue } from "./remote";
import { initializeWindowOnErrorHandler, lookupCashierId, lookupDeviceId, lookupStoreInfo, useConsole } from "./browser";
import { LogLevel } from "./types";
export class Logger {
  constructor(owner) {
    this.owner = owner;
    this.trace = this.loggingFunction(LogLevel.Trace);
    this.info = this.loggingFunction(LogLevel.Info);
    this.warn = this.loggingFunction(LogLevel.Warn);
    this.error = this.loggingFunction(LogLevel.Error);
    this.log = this.trace;
  }
  static initializeLogger({
    appVersion,
    commitSHA,
    namespace,
    logLevel,
    disableRemoteLogs = false,
    disableStringificationOnDevice = false,
    disableWindowOnErrorHandler = false,
    remoteConfig: {
      url: remoteURL
    }
  }) {
    Logger.logLevel = logLevel;
    Logger.disableRemoteLogs = disableRemoteLogs;
    Logger.disableStringificationOnDevice = disableStringificationOnDevice;
    if (!disableWindowOnErrorHandler) {
      initializeWindowOnErrorHandler(new Logger("window"));
    }
    if (!disableRemoteLogs) {
      const destroyRemoteLoggerSubjects = initializeRemoteLogQueue({
        appVersion,
        namespace,
        commitSHA,
        remoteURL
      });
      this.__destroy = () => {
        destroyRemoteLoggerSubjects();
      };
    }
  }
  get currentOrderId() {
    if (typeof Logger.getCurrentOrder !== "function") {
      return undefined;
    }
    const currentOrder = Logger.getCurrentOrder();
    if (!currentOrder || !currentOrder.orderId) {
      return undefined;
    }
    return currentOrder.orderId.toLowerCase();
  }
  get currentVehicleKey() {
    if (!Logger.getCurrentVehicle && !Logger.getCurrentOrder) {
      return undefined;
    }
    const currentVehicle = Logger.getCurrentVehicle();
    const currentOrder = Logger.getCurrentOrder();
    return currentVehicle && displayVehicleIdentifier(currentVehicle) || currentOrder && displayOrderVehicleIdentifier(currentOrder);
  }
  loggingFunction(severity) {
    return (action, ...messages) => {
      if (["trace", "info", "warn", "error"].indexOf(severity) < ["trace", "info", "warn", "error"].indexOf(Logger.logLevel)) {
        return;
      }
      if (localStorage.getItem("SHOW_LOGS")) {
        useConsole({
          fn: severity.match(/^(trace|info)$/) ? "log" : severity,
          process: this.owner,
          action: action,
          messages,
          stringify: !!window.device && !!window.device.uuid && !Logger.disableStringificationOnDevice
        });
      }
      if (Logger.disableRemoteLogs) {
        return;
      }
      const [message, ...additionalData] = messages;
      sendToRemoteLoggerQueue({
        process: this.owner,
        action,
        message,
        context: additionalData,
        severity,
        orderId: this.currentOrderId,
        vehicleKey: this.currentVehicleKey
      });
    };
  }
}
Logger.logLevel = LogLevel.Trace;
Logger.disableRemoteLogs = false;
Logger.disableStringificationOnDevice = false;
Logger.lookupCashierId = lookupCashierId;
Logger.lookupDeviceId = lookupDeviceId;
Logger.lookupStoreId = lookupStoreInfo;
Logger.getCurrentOrder = () => undefined;
Logger.getCurrentVehicle = () => undefined;
Logger.__destroy = () => {};
